<template>
  <div class="corporate-container">
    <!-- 装饰元素 -->
    <div class="decorative-line"></div>
    
    <!-- 合作标语 -->
    <div class="hero-section">
      <div class="glowing-border"></div>
      <h1>携手共赢 · 智创未来</h1>
      <p class="slogan">全球500强企业的战略选择 · 专业团队提供定制化解决方案</p>
      <div class="watermark">STRATEGIC</div>
    </div>

    <!-- 商务合作 -->
    <div class="section corporate-partners">
      <div class="section-header">
        <h2>战略合作中心<span class="decorative-dot"></span></h2>
        <p class="section-desc">我们致力于建立长期价值伙伴关系，提供以下合作机遇：</p>
      </div>
      <div class="cooperation-list">
        <div class="coop-item">技术研发合作</div>
        <div class="coop-item">供应链整合</div>
        <div class="coop-item">资本战略投资</div>
        <div class="coop-item">市场联合拓展</div>
      </div>
      <div class="executive-grid">
        <div v-for="(exec, index) in executives" :key="'e'+index" class="exec-card">
          <div class="title-box">
            <h3>{{ exec.name }}</h3>
            <div class="position">商务合作总监</div>
          </div>
          <div class="contact-box">
            <div class="contact-item">
              <svg class="icon" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              <a :href="'tel:'+exec.phone" class="phone-link">{{ exec.phone }}</a>
            </div>
            <div class="contact-item">
              <svg class="icon" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/></svg>
              <div class="email-wrap">
                <span class="email-user">{{ exec.email.split('@')[0] }}</span>
                <span class="email-domain">@{{ exec.email.split('@')[1] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 销售团队 -->
    <div class="section sales-team">
      <div class="section-divider">
        <span class="divider-text">区域服务网络</span>
      </div>
      <div class="sales-grid">
        <div v-for="(sales, index) in salesTeam" :key="'s'+index" class="sales-card">
          <div class="title-box">
            <h3>{{ sales.name }}</h3>
            <div class="region">{{ sales.region }}</div>
          </div>
          <div class="contact-box">
            <div class="contact-item">
              <svg class="icon" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
              <a :href="'tel:'+sales.phone" class="phone-link">{{ sales.phone }}</a>
            </div>
            <div class="contact-item">
              <svg class="icon" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/></svg>
              <div class="email-wrap">
                <span class="email-user">{{ sales.email.split('@')[0] }}</span>
                <span class="email-domain">@{{ sales.email.split('@')[1] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      executives: [
        { name: '总监1',   phone: '188-4085-4506', email: '18840854506@daliansnailvedio.top' },
        { name: '总监2', phone: '139-4204-8140', email: '13942048140@daliansnailvedio.top' }
      ],
      salesTeam: [
        { name: '马经理',  phone: '159-9853-2204', email: '15998532204@daliansnailvedio.top' },
        { name: '胡经理',  phone: '198-1895-8610', email: '19818958610@daliansnailvedio.top' },
        { name: '潘经理',  phone: '183-4268-0824', email: '18342680824@daliansnailvedio.top' }
      ]
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.corporate-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  position: relative;
  background: #f9fbfd;
}

/* 装饰元素 */
.decorative-line {
  position: absolute;
  top: 120px;
  left: 5%;
  width: 90%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(52,152,219,0.2), transparent);
}

.glowing-border {
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #3498db, #2c3e50);
  z-index: -1;
  border-radius: 10px;
  filter: blur(12px);
  opacity: 0.1;
}

.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 6rem;
  font-weight: 900;
  color: rgba(255,255,255,0.03);
  pointer-events: none;
  font-family: 'Arial Narrow';
}

/* 标语区 */
.hero-section {
  position: relative;
  text-align: center;
  padding: 4rem 0;
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  border-radius: 12px;
  margin-bottom: 3rem;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.1);
}

h1 {
  font-size: 2.5rem;
  letter-spacing: 2px;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.slogan {
  font-size: 1.1rem;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}

/* 通用板块样式 */
.section {
  margin-bottom: 3rem;
  position: relative;
}

.section-header {
  text-align: center;
  margin-bottom: 2rem;
}

h2 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.decorative-dot {
  width: 8px;
  height: 8px;
  background: #3498db;
  border-radius: 50%;
  display: inline-block;
}

.section-desc {
  color: #7f8c8d;
  font-size: 0.95rem;
  max-width: 600px;
  margin: 0 auto;
}

/* 合作项目 */
.cooperation-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 3rem;
}

.coop-item {
  padding: 1.2rem;
  background: rgba(52,152,219,0.03);
  border: 1px solid rgba(52,152,219,0.1);
  border-radius: 8px;
  text-align: center;
  font-weight: 500;
  color: #34495e;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(4px);
}

.coop-item:hover {
  background: rgba(52,152,219,0.1);
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(52,152,219,0.1);
}

/* 联系人卡片 */
.exec-card, .sales-card {
  background: rgba(255,255,255,0.98);
  border-radius: 12px;
  padding: 1.8rem;
  box-shadow: 0 8px 24px rgba(0,0,0,0.04);
  transition: transform 0.3s ease;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(52,152,219,0.08);
}

.exec-card::before, .sales-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #3498db, #2c3e50);
}

.exec-card:hover, .sales-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.08);
}

.title-box {
  margin-bottom: 1.2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(52,152,219,0.1);
}

h3 {
  font-size: 1.3rem;
  color: #2c3e50;
  margin-bottom: 0.3rem;
  font-weight: 600;
}

.position {
  font-size: 0.9rem;
  color: #7f8c8d;
  letter-spacing: 0.5px;
}

.region {
  font-size: 0.85rem;
  color: #27ae60;
  background: rgba(39,174,96,0.1);
  padding: 4px 12px;
  border-radius: 20px;
  display: inline-block;
}

/* 联系信息 */
.contact-box {
  display: grid;
  gap: 1.2rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  fill: #3498db;
}

.phone-link {
  color: #2c3e50;
  text-decoration: none;
  transition: color 0.3s;
  font-weight: 500;
}

.phone-link:hover {
  color: #3498db;
}

.email-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.email-user {
  color: #2c3e50;
  word-break: break-all;
}

.email-domain {
  color: #7f8c8d;
  font-size: 0.95em;
}

/* 分割线 */
.section-divider {
  position: relative;
  height: 1px;
  background: rgba(52,152,219,0.1);
  margin: 4rem 0;
}

.divider-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 0 2rem;
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 500;
  white-space: nowrap;
}

/* 网格布局 */
.executive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
}

.sales-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
}

/* 响应式优化 */
@media (max-width: 768px) {
  h1 {
    font-size: 2rem;
  }
  
  .hero-section {
    padding: 2rem 1rem;
  }
  
  .watermark {
    font-size: 3rem;
  }
  
  .cooperation-list {
    grid-template-columns: 1fr;
  }
  
  .exec-card, .sales-card {
    padding: 1.2rem;
  }
  
  .section-divider {
    margin: 3rem 0;
  }
}

@media (max-width: 480px) {
  .email-wrap {
    flex-direction: column;
  }
}
</style>